import React from "react";
import { TooltipMetadata } from "../../../../uiModel/tooltip/TooltipMetadata";
import { VolumeMutedIcon, VolumeQuietIcon, VolumeLoudIcon } from "../../../icons";
import { SliderComponent } from "../common/SliderComponent";
import { MenuButtonWithTooltipComponent } from "./MenuButtonWithTooltipComponent";

import "@styles/c-volumeControl.scss";

interface Props {
  isVolumeMuted: boolean;
  volume: number;
  onVolumeChange: (volume: number) => void;
  onToggleMuted: () => void;
  onCancelTooltip: () => void;
  onRequestTooltip: (metadata: TooltipMetadata) => void;
  className?: string;
}

interface State {
  isHovered: boolean;
  isChangingVolume: boolean;
}

export class VolumeControlComponent extends React.Component<Props, State> {
  private static LOUD_VOLUME_THRESHOLD = 0.5;

  constructor(props: Props) {
    super(props);
    this.state = {
      isHovered: false,
      isChangingVolume: false,
    };
  }

  render() {
    const { isVolumeMuted, volume, onToggleMuted, onCancelTooltip, onRequestTooltip, className } = this.props;
    const displayedVolume = isVolumeMuted ? 0 : volume;

    return (
      <div
        className={`c-volumeControl ${className || ""}`}
        onMouseEnter={() => this.toggleHovered(true)}
        onMouseLeave={() => this.toggleHovered(false)}
      >
        <div className="c-volumeControl__button">
          <MenuButtonWithTooltipComponent
            onClick={onToggleMuted}
            icon={this.renderVolumeIconSvg(isVolumeMuted, displayedVolume)}
            tooltipTarget="volumeControl"
            onCancelTooltip={onCancelTooltip}
            onRequestTooltip={onRequestTooltip}
          />
        </div>
        <div className="c-volumeControl__spacer" />
        {(this.state.isHovered || this.state.isChangingVolume) && (
          <div className="c-volumeControl__slider">
            <SliderComponent
              value={displayedVolume}
              onSliderInteraction={(value, isChanging) => this.handleSliderInteraction(value, isChanging)}
              onSliderInteractionEnded={() => this.handleSliderInteractionEnd()}
            />
          </div>
        )}
      </div>
    );
  }

  private renderVolumeIconSvg(isVolumeMuted: boolean, volume: number) {
    if (isVolumeMuted) {
      return <VolumeMutedIcon />;
    } else if (volume < VolumeControlComponent.LOUD_VOLUME_THRESHOLD) {
      return <VolumeQuietIcon />;
    }
    return <VolumeLoudIcon />;
  }

  private toggleHovered(isHovered: boolean): void {
    this.setState({
      isHovered,
    });
  }

  private handleSliderInteraction(value: number, isChanging: boolean): void {
    if (isChanging) {
      if (!this.state.isChangingVolume) {
        this.setState({
          isChangingVolume: true,
        });
      }
      this.props.onVolumeChange(value);
    }
  }

  private handleSliderInteractionEnd() {
    this.setState({
      isChangingVolume: false,
    });
  }
}
